import React from 'react'

const Whishlist = () => {
  return (
    <div>Whishlist</div>
  )
}

export default Whishlist
